import React, {forwardRef} from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import {useTranslation} from "react-i18next";
import css from "./EmptyContent.module.scss";

const EmptyContent = forwardRef(({children, className, name, ...rest}, ref) => {
  const {t} = useTranslation();

  return (
    <div
      className={classNames(css.emptyContent, className)}
      ref={ref}
      {...rest}>
      {name ? t("misc.emptyData", {name: name.toLowerCase()}) : children}
    </div>
  );
});

EmptyContent.propTypes = {
  /**
   * Any content to render within the component if no "name" prop
   * is passed.
   *
   * @defaultValue null
   */
  children: PropTypes.any,

  /**
   * A string that can be passed _instead_ of a child component that will
   * render a generic "No (name) to show" statement.
   *
   * @defaultValue null
   */
  name: PropTypes.string
};

export default EmptyContent;
